<template lang="pug">
.summary-panel
  table.legends
    thead
      tr
        th(colspan="2") Resumen
    tbody
      tr
        td Proyectos:
        td
          span(v-show="summary.filter.projects !== summary.total.projects") {{summary.filter.projects}} de
          span {{summary.total.projects}}
      tr
        td Familias:
        td
          span(v-show="summary.filter.families !== summary.total.families") {{summary.filter.families.toLocaleString('es')}} de
          span {{summary.total.families.toLocaleString('es')}}
      tr
        td Inversión:
        td
          span(v-show="summary.filter.cost !== summary.total.cost") {{summary.filter.cost.toLocaleString('es')}} de
          span {{summary.total.cost.toLocaleString('es')}} USD
      tr
        td Cota:
        td
          span 63 (9mts - máxima)

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SummaryPanel',
  computed: {
    ...mapGetters([
      'summary'
    ])
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'
$background-color = rgba(32, 40, 53, .4)

.summary-panel
  background-color: $background-color
  border: 1px solid white
  border-radius: $f4px
  color: white
  max-width: 14rem
  table
    border-collapse: collapse
    width: 100%
  td, th
    border-bottom: $f1px solid white
    padding: $f3px
  td:first-child
    font-weight: bold
  tr:last-child td
    border-bottom-width: 0
</style>
